export const FONT_TOOLBAR_BUTTON = 'font';
export const SHORTCODE_TOOLBAR_BUTTON = 'shortcode';
export const BLOCKQUOTE_TOOLBAR_BUTTON = 'blockquote';
export const BOLD_TOOLBAR_BUTTON = 'bold';
export const CODE_BLOCK_TOOLBAR_BUTTON = 'code-block';
export const CODE_TOOLBAR_BUTTON = 'code';
export const DECREASE_IDENT_TOOLBAR_BUTTON = 'decrease-indent';
export const DELETE_COLUMN_TOOLBAR_BUTTON = 'delete-column';
export const DELETE_ROW_TOOLBAR_BUTTON = 'delete-row';
export const DELETE_TABLE_TOOLBAR_BUTTON = 'delete-table';
export const INCRASE_IDENT_TOOLBAR_BUTTON = 'increase-indent';
export const INSERT_COLUMN_TOOLBAR_BUTTON = 'insert-column';
export const IMAGE_TOOLBAR_BUTTON = 'image';
export const FILE_LINK_TOOLBAR_BUTTON = 'file-link';
export const INSERT_ROW_TOOLBAR_BUTTON = 'insert-row';
export const INSERT_TABLE_TOOLBAR_BUTTON = 'insert-table';
export const ITALIC_TOOLBAR_BUTTON = 'italic';
export const ORDERED_LIST_TOOLBAR_BUTTON = 'ordered-list';
export const STRIKETHROUGH_TOOLBAR_BUTTON = 'strikethrough';
export const UNORDERED_LIST_TOOLBAR_BUTTON = 'unordered-list';
